import { createClient } from '@supabase/supabase-js'

const supabaseUrl = import.meta.env.VITE_SUPABASE_URL
const supabaseKey = import.meta.env.VITE_SUPABASE_ANON_KEY
const rememberSessionKey = "uppgerd-remember-session"
const localStorageKey = "sb-uppgerd-auth-token"
const memoryStorage = new Map<string, string>()

const selectedStorage = {
  getItem: (key: string) => {
    const rememberSession = localStorage.getItem(rememberSessionKey) === "true"
    return rememberSession ? localStorage.getItem(key) : sessionStorage.getItem(key) ?? memoryStorage.get(key) ?? null
  },
  setItem: (key: string, value: string) => {
    const rememberSession = localStorage.getItem(rememberSessionKey) === "true"
    if (rememberSession) {
      localStorage.setItem(key, value)
      sessionStorage.removeItem(key)
      memoryStorage.delete(key)
      return
    }

    sessionStorage.setItem(key, value)
    localStorage.removeItem(key)
    memoryStorage.set(key, value)
  },
  removeItem: (key: string) => {
    localStorage.removeItem(key)
    sessionStorage.removeItem(key)
    memoryStorage.delete(key)
  },
}

export const setRememberSession = (remember: boolean) => {
  localStorage.setItem(rememberSessionKey, remember ? "true" : "false")

  const localValue = localStorage.getItem(localStorageKey)
  const sessionValue = sessionStorage.getItem(localStorageKey)
  const value = localValue ?? sessionValue

  if (!value) return

  if (remember) {
    localStorage.setItem(localStorageKey, value)
    sessionStorage.removeItem(localStorageKey)
  } else {
    sessionStorage.setItem(localStorageKey, value)
    localStorage.removeItem(localStorageKey)
  }
}

export const getRememberSession = () => localStorage.getItem(rememberSessionKey) === "true"

if (!supabaseUrl || !supabaseKey) {
  throw new Error("Missing Supabase environment variables.")
}

if (supabaseKey.includes("service_role")) {
  throw new Error("Never expose the Supabase service_role key in the frontend.")
}

export const supabase = createClient(supabaseUrl, supabaseKey, {
  auth: {
    autoRefreshToken: true,
    detectSessionInUrl: true,
    persistSession: true,
    storageKey: localStorageKey,
    storage: selectedStorage,
  },
})
